import React from 'react';
import { Link } from 'react-router-dom';

const Sidebar = ({ blogs, search, setSearch }) => {
  return (
    <div className='space-y-2'>
      <input
        className='py-2 px-2 rounded-lg w-full sm:w-7/12 md:w-full focus:ring-1 focus:ring-gray-300 outline-none text-black'
        type='text'
        placeholder={'Search ...'}
        onChange={(e) => setSearch(e.currentTarget.value)}
        value={search}
      />
      <div>
        <p className='font-bold text-gray-800'> Recent Posts</p>
        {blogs ? (
          blogs
            .map((blog) => (
              <Link to={`/blog/${blog.id}`} key={blog.id}>
                <p className='flex text-sm md: text-base my-2'>{blog.title} </p>
              </Link>
            ))
            .reverse()
            .slice(0, 4)
        ) : (
          <p className='text-gray-800'>{'No Post To Display'}</p>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
